import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts'
import drilldown from "highcharts/modules/drilldown.js";
import { useEffect, useState } from "react";
import { useArgonController } from "context";
import colorsDark from "assets/theme-dark/base/colors";
import colors from "assets/theme/base/colors";

require("highcharts/modules/exporting")(Highcharts);
drilldown(Highcharts)

const StrukturAnggaranChartBar = ({ data, title }) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;

    const [options, setOptions] = useState({})

    useEffect(() => {
        setOptions({
            chart: {
                type: 'bar',
                backgroundColor: darkMode && colorsDark.background.dark
            },
            title: {
                align: 'center',
                text: title,
                style: {
                    color: darkMode ? colorsDark.text.main : colors.text.main
                }
                // margin: 35
            },
            lang: {
                numericSymbols: null,
                thousandsSep: ','
            },
            subtitle: {
                align: 'center',
                // text: 'Klik kecamatan untuk melihat Data Kelurahan'
            },
            accessibility: {
                announceNewData: {
                    enabled: true
                }
            },
            xAxis: {
                type: 'category',
                labels: {
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    },
                    format: '{value}'
                }
            },
            yAxis: {
                title: {
                    text: 'Anggaran',
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    }
                },
                gridLineWidth: 0,
                // lineColor: 'transparent',
                // minorTickLength: 0,
                // tickLength: 0
                labels: {
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    },
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: true,
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:,.f}'
                    }
                }
            },
        
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>'
            },
            series: [
                {
                    name: 'Anggaran',
                    colorByPoint: true,
                    data: data.series
                },
            ],
            drilldown: {
                breadcrumbs: {
                    position: {
                        align: 'left'
                    }
                },
                activeAxisLabelStyle: {
                    textDecoration: 'none',
                    color: darkMode ? colorsDark.text.main : colors.text.main,
                    // fontStyle: 'italic',
                    fontWeight: 'normal'
                },
                activeDataLabelStyle: {
                    textDecoration: 'none',
                    color: darkMode ? colorsDark.text.main : colors.text.main
                    // fontWeight: 'normal'
                },
                series: data.jenis
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, darkMode])

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )
}

StrukturAnggaranChartBar.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
}

export default StrukturAnggaranChartBar